import { EditabilityBasedOnProcessStatus } from './editabilityBasedOnProcessStatus';
import { AddressAndPersonalData } from './personal-data/addressAndPersonalData';
import { ConnectionAddress } from './personal-data/connectionAddress';
import { SubscriberAddress } from './personal-data/subscriberAddress';
import { DocumentsSectionsState } from './sections-state/documentsSectionsState';
import { PersonalDataSectionsState } from './sections-state/personalDataSectionsState';
import { TechnicalSpecificationsSectionsState } from './sections-state/technicalSpecificationsSectionsState';
import { TechnicalData } from './technicalData';
import { ContactPerson, Document } from 'src/app/jurisdiction/jurisdiction.domain';

export class GridApplication {
  application_id: string;
  application_ext_id?: string;
  user_id: string;
  building_con_from?: string;
  comment: string;
  installation_comment?: string;
  desired_date: string;
  technician_id: string;
  application_date: string;
  objective: string;
  sk_installation_type: string;
  sk_status: string;
  sk_type: string;
  confirm_chimneysweeper_report?: string;
  confirm_g600?: string;
  confirm_ndav?: string;
  chimney_sweeper_id?: string;
  applicant_is_landowner?: string;
  applicant_is_invoicerecipient?: string;
  is_operator_agreement_confirmed?: string;
  sk_application_type: string;
  last_changed: string;
  determinated_price: string;
  archived: string;
  locked: string;
  lockedby: string;
  technical_conditions_met: string;

  businesspartner: SubscriberAddress;
  connectionobject: ConnectionAddress;
  technical_data: TechnicalData;
  app_power_plant_operator_address: AddressAndPersonalData;
  invoicerecipient?: AddressAndPersonalData;
  document?: Document[];

  technical_specifications_sections_state: TechnicalSpecificationsSectionsState;
  personal_data_sections_state: PersonalDataSectionsState;
  documents_sections_state: DocumentsSectionsState;
  contact_person?: ContactPerson;

  process_status: EditabilityBasedOnProcessStatus;
}
